"use client";
import React from "react";
import { FaCheck } from "react-icons/fa";
import { cn } from "~/utils/fontsConfig";

type StepProps = {
    number: number;
    label: string;
    isActive: boolean;
    isCompleted: boolean;
    isLast: boolean;
};

const Step = ({ number, label, isActive, isCompleted, isLast }: StepProps) => (
    <div className="flex w-24 flex-col items-center">
        <div className="relative flex w-full items-center justify-center">
            <div
                className={cn(
                    "z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold",
                    isActive
                        ? "bg-v3-O300 text-white"
                        : isCompleted
                          ? "bg-v3-C500 text-v3-N600"
                          : "bg-v3-N500 text-v3-N300",
                )}
            >
                {isCompleted ? <FaCheck /> : number}
            </div>
            {!isLast && (
                <div className="absolute left-1/2 -z-10 h-[2px] w-[90%] bg-v3-N400" />
            )}
        </div>
        <span
            className={cn(
                "mt-2 text-center text-xs",
                isActive ? "text-white" : "text-v3-N300",
            )}
        >
            {label}
        </span>
    </div>
);

type Props = {
    currentStep: number;
    stepRanges?: {
        start: number;
        end: number;
    };
};

const Stepper = ({ currentStep, stepRanges }: Props) => {
    const allSteps = [
        { label: "Select plan", number: 1 },
        { label: "Information", number: 2 },
        { label: "Summary", number: 3 },
        { label: "Payment hold", number: 4 },
    ];

    const steps = stepRanges
        ? allSteps.slice(stepRanges.start, stepRanges.end + 1)
        : allSteps;

    return (
        <div className="flex w-full items-center justify-center">
            <div className="flex w-72">
                {steps.map((step, index) => (
                    <Step
                        key={step.number}
                        number={step.number}
                        label={step.label}
                        isActive={
                            currentStep === index + (stepRanges?.start ?? 0)
                        }
                        isCompleted={
                            currentStep > index + (stepRanges?.start ?? 0)
                        }
                        isLast={index === steps.length - 1}
                    />
                ))}
            </div>
        </div>
    );
};

export default Stepper;
